import { Maybe } from '~/gql/__generated__/types';

type props = {
  content: Maybe<string> | undefined;
  className?: string;
};
export const RichText: React.FC<props> = ({ content, className }) => {
  if (!content) {
    return null;
  }
  const innerHtml = { __html: content };
  return <span className={className} dangerouslySetInnerHTML={innerHtml} />;
};
